import { createSlice } from "@reduxjs/toolkit";
// import storage from "../../services/storage";

//const token = storage.get("classToken") || "";

const initialState = {
  bookLoader: false,
  activitiesLoader: true,
  studentActivityLoader: false,
};

const slice = createSlice({
  name: "loaders",
  initialState,

  reducers: {
    setBookLoader: (state, action) => {
      state.bookLoader = action.payload;
    },
    setActivitiesLoader: (state, action) => {
      state.activitiesLoader = action.payload;
    },
    setStudentActivityLoader: (state, action) => {
      state.studentActivityLoader = action.payload;
    },
  },
});

export const { setBookLoader, setActivitiesLoader, setStudentActivityLoader } =
  slice.actions;
export default slice.reducer;
